import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift, faClipboard, faCheck } from '@/fontawesome';
import Modal from '@/components/ui/Modal';
import type { PromotionConfig } from '@/modelsLocal/promotion-modal';

interface PromotionModalProps {
  config: PromotionConfig;
  isOpen: boolean;
  onClose: () => void;
}

export default function PromotionModal({ config, isOpen, onClose }: PromotionModalProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(config.couponCode).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={config.title}
      icon={<FontAwesomeIcon icon={faGift} className="w-5 h-5 text-blue-600 dark:text-blue-400" />}
      maxWidth="md"
    >
      <div className="p-6 space-y-4">
        {config.imageUrl !== '' && (
          <img
            src={config.imageUrl}
            alt={config.title}
            className="w-full rounded-lg object-cover"
          />
        )}

        <p className="text-gray-700 dark:text-gray-300 text-sm leading-relaxed whitespace-pre-line">
          {config.longDescription}
        </p>

        <div>
          <p className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 uppercase tracking-wide">
            Gutscheincode
          </p>
          <div className="flex items-center gap-2 bg-gray-100 dark:bg-gray-700 rounded-lg p-3">
            <span className="flex-1 font-mono font-bold text-gray-900 dark:text-white tracking-widest">
              {config.couponCode}
            </span>
            <button
              onClick={handleCopy}
              className="flex items-center gap-1.5 px-3 py-1.5 text-sm bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 text-white rounded-md transition-colors cursor-pointer font-medium"
            >
              <FontAwesomeIcon icon={copied ? faCheck : faClipboard} className="w-3.5 h-3.5" />
              {copied ? 'Kopiert!' : 'Kopieren'}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
